import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const CreateRmaPage = loadable(() => withDefaultLoaderModifiers(import("./CreateRmaPage")));
